<template>
  <n-layout embedded content-style="padding: 12px;" class="card">
    <n-card style="min-height: 100vh">
      <DaySchedule v-if="viewMode == 'DAY'" />
      <MonthSchedule v-else />
    </n-card>
  </n-layout>
</template>

<script>
import DaySchedule from '@/components/DaySchedule.vue';
import MonthSchedule from '@/components/MonthSchedule.vue';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
export default {
  name: 'Home',
  components: {
    DaySchedule,
    MonthSchedule,
  },
  setup() {
    const store = useStore();
    const viewMode = ref(
      computed(() =>
        JSON.parse(JSON.stringify(store.state.viewMode)),
      ),
    );
    return {
      viewMode,
    };
  },
};
</script>
<style>
.card {
  background-color: #eaea7f;
}
</style>
